module.exports = __webpack_public_path__ + "img/21_70.9a839612.png";